import styled from '@emotion/styled';

export const StyledReportArea = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  padding: 25px 30px;
  & > strong {
    position: relative;
    display: block;
    width: 245px;
    min-width: 245px;
    height: 24px;
    font-size: 16px;
    line-height: 23px;
  }
`;

export const StyledReportFlex = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 30px;
  color: #555;

  & span {
    font-weight: 400;
    font-size: 14px;
  }

  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }
`;

export const StyledSendItemFlex = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #555;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }

  li {
    margin-left: 20px;

    div {
      height: 40px;

      input {
        height: 24px;
        font-size: 16px;
        line-height: 23px;
      }
    }
  }
`;

export const StyledSeriesList = styled.ul`
  display: flex;
  & li {
    display: flex;
    & + li {
      margin-left: 30px;
    }
  }
`;

export const StyledSeriesConfigFlex = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #555;
  &:before {
    content: '';
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #e0e0e0;
  }

  li {
    margin-left: 20px;

    div {
      height: 40px;

      input {
        height: 24px;
        font-size: 16px;
        line-height: 23px;
      }
    }
  }
`;

export const StyledInputList = styled.ul`
  position: relative;
  display: flex;
  align-items: center;

  & li {
    margin-right: 50px;
  }
  & .sub-title {
    width: 150px;
  }
  & .send-off {
    margin-left: 5px;
  }
`;
